import Chip from '@material-ui/core/Chip';
import FilledInput from '@material-ui/core/FilledInput';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { makeStyles } from '@material-ui/core/styles';
import _isEmpty from 'lodash/isEmpty';
import React from 'react';
import { Props } from '../types';

const useStyles = makeStyles({
  input: {
    backgroundColor: 'white',
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: 2,
  },
});

const FilterMultivalue: React.FC<Props> = ({
  optionList,
  label,
  id,
  filterClassName,
  value,
  onChange,
}) => {
  const classes = useStyles();

  return (
    <FormControl variant="filled" className={filterClassName} fullWidth>
      <InputLabel htmlFor={id} shrink>
        {label}
      </InputLabel>
      <Select
        value={_isEmpty(value) ? [''] : value}
        onChange={onChange as any}
        input={<FilledInput name={id} id={id} className={classes.input} />}
        displayEmpty
        multiple
        renderValue={(selected) => (
          <div className={classes.chips}>
            {(selected as string[]).map((value, index) => {
              const label = value === '' ? 'All' : value;
              return <Chip key={index} label={label} className={classes.chip} />;
            })}
          </div>
        )}
      >
        <MenuItem value="">All</MenuItem>
        {optionList.map((option, index) => (
          <MenuItem key={index} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default FilterMultivalue;
